import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { RouterOutletComponent } from '@abp/ng.core';
import { AuditLoggingExcelDownloadComponent } from './audit-logging/audit-logging-excel-download/audit-logging-excel-download.component';

const routes: Routes = [
  {
    path: '',
     component: RouterOutletComponent,
    children: [
      {
        path: 'download-audit-logging-excel/:fileName',
        component: AuditLoggingExcelDownloadComponent,
      },
    ],
  },
];

@NgModule({
  declarations: [AuditLoggingExcelDownloadComponent],
  imports: [CommonModule, RouterModule.forChild(routes)],
})
export class ReportModule {}
